<template>
  <router-link
    v-if="!to.startsWith('http')"
    class="rl"
    :to="to"
  >
    <slot />
  </router-link>
  <a
    v-if="to.startsWith('http')"
    :href="to"
    target="_blank"
  ><slot /></a>
</template>

<script>
export default {
  name: 'AppLink',
  props: [
      'to'
  ]
};
</script>

<style scoped>

</style>